// Einwilligung (Cookie-Banner) und alles, was davon abhängt: PostHog (Statistik) und Google Ads (Marketing).
// Vor einer Zustimmung wird keiner der Dienste geladen: keine Anfrage, kein Cookie, kein Eintrag im Browser-Speicher
// außer der gespeicherten Auswahl selbst. Auf Vorschau-Adressen (window.__IS_PREVIEW__, siehe public/vorschau.js) nie.

const SPEICHER = "cookie_consent_v2";
const SPEICHER_ALT = "cookie_consent"; // frühere Fassung des Banners: "yes" oder "no"
const POSTHOG_KEY = "phc_kYZI6XoEYsWzqSpDY6HFHFXMENVIFH31RhY6qI7dECI";
const POSTHOG_HOST = "https://eu.i.posthog.com";
const GOOGLE_ADS_ID = "AW-17423941064";
const KONTAKT_CONVERSION = "AW-17423941064/9wh8CP_ekLwbEMj7sPRA";
const VORSCHAU = window.__IS_PREVIEW__ === true;

export const OEFFNEN_EVENT = "cookie-einstellungen-oeffnen";

let posthog = null; // erst nach Einwilligung geladen
let posthogGestartet = false;
let googleGestartet = false;

// Gespeicherte Auswahl { statistik, marketing } oder null, solange nichts entschieden ist
export function leseEinwilligung() {
  try {
    const roh = localStorage.getItem(SPEICHER);
    if (roh) {
      const w = JSON.parse(roh);
      return { statistik: w.statistik === true, marketing: w.marketing === true };
    }
    const alt = localStorage.getItem(SPEICHER_ALT);
    if (alt === "yes") return { statistik: true, marketing: true };
    if (alt === "no") return { statistik: false, marketing: false };
  } catch {
    // Speicher gesperrt (z. B. privater Modus): wie "nicht entschieden"
  }
  return null;
}

export function speichereEinwilligung(auswahl) {
  const vorher = leseEinwilligung();
  try {
    localStorage.setItem(SPEICHER, JSON.stringify({ ...auswahl, stand: new Date().toISOString() }));
    localStorage.removeItem(SPEICHER_ALT);
  } catch {}

  const widerrufen = (vorher?.statistik && !auswahl.statistik) || (vorher?.marketing && !auswahl.marketing);
  if (widerrufen) {
    // Geladene Skripte lassen sich nicht entladen: Daten löschen und Seite ohne sie neu laden
    entferneDaten(auswahl);
    window.location.reload();
    return;
  }
  starteDienste(auswahl);
}

export function oeffneCookieEinstellungen() {
  window.dispatchEvent(new Event(OEFFNEN_EVENT));
}

// Beim Seitenstart: Reste widerrufener Dienste löschen, eingewilligte Dienste starten
export function starteEinwilligung() {
  const auswahl = leseEinwilligung();
  entferneDaten(auswahl || { statistik: false, marketing: false });
  if (auswahl) starteDienste(auswahl);
}

// Erfolgreich abgeschicktes Kontaktformular (Google-Ads-Conversion und PostHog-Ereignis)
export function meldeKontaktanfrage() {
  if (googleGestartet) {
    window.gtag("event", "conversion", { send_to: KONTAKT_CONVERSION, value: 1.0, currency: "EUR" });
  }
  if (posthog) posthog.capture("kontakt_gesendet");
}

function starteDienste(auswahl) {
  if (VORSCHAU) return;
  if (auswahl.statistik) startePostHog();
  if (auswahl.marketing) starteGoogleAds();
}

function startePostHog() {
  if (posthogGestartet) return;
  posthogGestartet = true;
  // Eigene Datei, die nur Besucher mit Einwilligung herunterladen
  import("posthog-js").then(({ default: ph }) => {
    ph.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      persistence: "localStorage",
      capture_pageview: "history_change", // auch Seitenwechsel innerhalb der App
      autocapture: false,
      person_profiles: "identified_only",
      // Nur Seitenaufrufe und eigene Ereignisse, so wie in der Datenschutzerklärung beschrieben
      disable_session_recording: true,
      disable_surveys: true,
      disable_web_experiments: true,
      capture_heatmaps: false,
      capture_dead_clicks: false,
      capture_exceptions: false,
    });
    posthog = ph;
  });
}

function starteGoogleAds() {
  if (googleGestartet) return;
  googleGestartet = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  // Eingewilligt ist die Messung des Werbeerfolgs, keine personalisierte Werbung (Remarketing)
  window.gtag("consent", "default", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS_ID);
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(s);
}

function entferneDaten(auswahl) {
  if (!auswahl.statistik) {
    try {
      Object.keys(localStorage)
        .filter((k) => k.startsWith("ph_") || k.startsWith("__ph_"))
        .forEach((k) => localStorage.removeItem(k));
    } catch {}
    loescheCookies(["ph_"]);
  }
  if (!auswahl.marketing) loescheCookies(["_gcl_"]);
}

// Cookies können für die Adresse selbst oder eine übergeordnete Domain gesetzt sein: alle Varianten löschen
function loescheCookies(praefixe) {
  const teile = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < teile.length - 1; i++) domains.push(`; domain=.${teile.slice(i).join(".")}`);
  document.cookie
    .split(";")
    .map((c) => c.split("=")[0].trim())
    .filter((name) => praefixe.some((p) => name.startsWith(p)))
    .forEach((name) =>
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d}`;
      })
    );
}
